import { createApp } from "vue";
import UserCorporatePage from "~/components/UserAccounts/UserCorporatePage";
import * as dayjs from "dayjs";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

document.addEventListener("DOMContentLoaded", () => {
  const app = createApp({
    components: {
      UserCorporatePage
    }
  });
  app.config.globalProperties.$dayjs = dayjs;
  app.use(FloatingVue);
  app.mount("#corporation-contents");
});
